import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./img.component.html",
})
export class FormlyImage extends FieldType<FieldTypeConfig> {
    private domSanitizer: DomSanitizer;

    constructor(domSanitizer: DomSanitizer) {
        super();

        this.domSanitizer = domSanitizer;
    }

    getSource(path: string) {
        path = path || "";

        if (path.startsWith("data:image/"))
            return this.domSanitizer.bypassSecurityTrustUrl(path);

        return path;
    }
}
